<template>
  <div>
    <div @click="showDialog">
      <div v-if="textList.length">
        <el-tag v-for="(item,index) in textList" :key="index" style="margin:4px;">{{ item }}</el-tag>
      </div>
      <div v-else>{{ placeholder }}</div>
    </div>
    <el-dialog
      title="楼栋选择"
      :visible.sync="visible"
      width="600px"
      destroy-on-close
      :append-to-body="true"
    >
      <div
        v-loading="buildLoading"
        style="min-height: 400px;max-height:calc(100vh - 600px);overflow: auto;margin-top:10px;"
      >
        <el-tree
          ref="tree"
          :data="dataTree"
          show-checkbox
          node-key="id"
          :default-expand-all="false"
          render-after-expand
          :props="defaultProps"
          @check="change"
        />
      </div>
      <div slot="footer" class="dialog-footer text-center">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buildingTree } from '@/api/common'
export default {
  name: 'UmBusBuilding',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    treeData: {
      type: Object,
      default: () => {}
    },
    text: {
      type: String, // 以逗号分割
      default: ''
    },
    placeholder: {
      type: String,
      default: '暂无数据'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      textList: [],
      visible: false,
      dataTree: [],
      checkedNodes: [],
      buildLoading: false,
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    }
  },
  watch: {
    text(val) {
      if (val !== this.textList.join(',')) {
        this.textList = this.text.split(',')
      }
    },
    treeData(val) {
      // todo 当搜索条件改变的时候 是否刷新数据
    }
  },
  created() {
    if (this.text) {
      this.textList = this.text.split(',')
    }
  },
  mounted() {},
  methods: {
    init() {
      return new Promise((resolve, reject) => {
        const list = []
        this.checkedNodes.forEach((item) => {
          const node = this.$refs.tree.getNode(item.id)
          if (node.parent && node.parent.checked) {
            //
          } else {
            const text = []
            this.deep(node, text)
            list.push(text.reverse().join('-'))
          }
        })
        resolve(list)
        // this.textList = list
      })
    },
    filterNode(value, data, node) {
      if (!value) return true
      return node.label.indexOf(value) !== -1
    },
    deep(node, text) {
      if (node.parent && node.parent.label) {
        text.push(node.label)
        this.deep(node.parent, text)
      } else {
        text.push(node.label)
      }
    },
    getTree() {
      this.buildLoading = true
      buildingTree({
        ...this.treeData
      })
        .then((d) => {
          this.dataTree = d.data.buildingTree
          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys(this.value)
            this.checkedNodes = this.$refs.tree.getCheckedNodes()
            this.init().then((list) => {
              this.buildLoading = false
              this.textList = list
            })
          })
        })
        .catch(err => {
          this.buildLoading = false
        })
    },
    change(
      data,
      { checkedKeys, checkedNodes, halfCheckedKeys, halfCheckedNodes }
    ) {
      // console.log(checkedNodes)
      // this.checkedNodes = checkedNodes
    },
    submit() {
      this.checkedNodes = this.$refs.tree.getCheckedNodes()
      this.init().then((data) => {
        this.textList = data
        const list = this.$refs.tree.getCheckedNodes(true)
        const keys = this.$refs.tree.getCheckedKeys(true)
        this.$emit('change', keys)
        this.$emit('change-all', list, this.textList)
        this.visible = false
      })
    },
    showDialog() {
      if (this.disabled) return
      this.visible = true
      this.getTree()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
